import {Notification} from './components/Toast';
import {AppRoutes} from './routes';


const App = () => {
  return <div className="App">
    <Notification />
    <AppRoutes />
  </div>  
}

export default App;
